import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { CurrentService, Element, ElementsService, ProjectService, BillOperate } from 'dbweb-core';
import { forkJoin, Subscription, Subject, of } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { TabsService } from '../../home/tabs.service';
import { EleViewBackFaceService } from '../../services/eleview/eleview-backface';
import { map2WithLetter } from '../../services/eleview/mapletter';
import { OwnerByEnum } from '../../services/eleview/types/model';
import { ElementViewDigest } from '../model/element-columns-digest';
import { IDisplayColumn, Order, IRecordViewProcess } from '../model/model';
import { DataType, Operate, Operates } from '../model/operate';
import { BackFaceService } from './backface';
import { combLabelColumnsItem, ServiceData, ConditionalTemplateRunner, defaultColumnsItem } from './data';
import { HttpErrorResponse } from '@angular/common/http';

export class EditView {
	titleInput = true;
	isAdd = true;
	addOwnerBy = OwnerByEnum.ownerByUser; // ä»æ°å¢æ¶ç¨å°
	title?: string;
	private _current?: ElementViewDigest;
	Readonly?: boolean;
	SelectedColumns?: IDisplayColumn[];
	modify = false; // currentæ¯å¦è¢«ä¿®æ¹è¿
	currentChange = new EventEmitter();
	get current() {
		return this._current;
	}
	set current(val: ElementViewDigest) {
		const process = () => {
			this._current = val;
			this.Readonly = !this._current.canModify(this.svr.current.data.UserName, this.svr.current.data.Dept.Code);
			this.currentChange.emit();
		};
		if (val === combLabelColumnsItem) {
			this.svr.backface.comboLabelsView().subscribe(cols => {
				this.SelectedColumns = cols.map<IDisplayColumn>(col => ({
					Name: col,
					Hidden: false,
					Order: Order.OrderNone
				}));
			});
			process();
		} else {
			this.svr.backface.getViewColumns(val).subscribe(cols => {
				this.SelectedColumns = cols;
				process();
			});
		}
	}
	constructor(private svr: ServiceService) {}

	done() {
		if (this.isAdd) {
			const view = {
				Name: this.title,
				OwnerBy: this.addOwnerBy,
				Owner:
					this.addOwnerBy === OwnerByEnum.ownerByDept
						? this.svr.current.data.Dept.Code
						: this.svr.current.data.UserName
			};
			return this.svr.backface.addView(view).pipe(
				map(() => {
					const dView = ElementViewDigest.fromInterface(view);
					this.svr.data.viewList.push(dView);
					this.current = dView;
					this.titleInput = false;
					return true;
				})
			);
		} else {
			return this.svr.backface
				.updateViewName({
					OldName: this.current.Name,
					Name: this.title,
					OwnerBy: this.current.OwnerBy,
					Owner: this.current.Owner
				})
				.pipe(
					map(v => {
						this.current.Name = this.title;
						this.titleInput = false;
						return true;
					})
				);
		}
	}
	remove() {
		this.svr.backface.removeView(this.current).subscribe(() => {
			const num = this.svr.data.viewList.findIndex(v => v === this.current);
			this.svr.data.viewList.splice(num, 1);
			if (this.svr.data.viewList.length > 0) {
				if (num < this.svr.data.viewList.length) {
					this.current = this.svr.data.viewList[num];
				} else {
					this.current = this.svr.data.viewList[this.svr.data.viewList.length - 1];
				}
			} else {
				this.current = this.svr.data.constViewItems[0];
			}
		});
	}
	add() {
		this.title = 'æ°çè§å¾';
		this.isAdd = true;
		this.titleInput = true;
	}
	edit() {
		this.title = this._current.Name;
		this.isAdd = false;
		this.titleInput = true;
	}
	cancel() {
		this.titleInput = false;
		if (!this.current) {
			if (this.svr.data.viewList && this.svr.data.viewList.length > 0) {
				this.current = this.svr.data.viewList[0];
			} else {
				this.current = this.svr.data.constViewItems[0];
			}
		}
	}
	save() {
		return this.svr.backface
			.updateView({
				Name: this.current.Name,
				OwnerBy: this.current.OwnerBy,
				Owner: this.current.Owner,
				Columns: this.SelectedColumns
			})
			.pipe(
				tap(() => {
					this.modify = false;
				})
			);
	}
}

export interface RefreshDataConfig {
	keepDivide?: boolean;
	keepRowCount?: boolean;
}

@Injectable()
export class ServiceService implements OnDestroy {
	private subscribe: Subscription[] = [];
	element: Element;
	editView = new EditView(this);
	paramsChange = new Subject(); // åæ°åçååï¼ä¸è¬æ¯åå§åæ¶ä¸æ¬¡ï¼åæ¢å¤çå°ä¸æ¬¡
	// æ ç­¾å®ä¹çé¢çæ°æ®
	refreshDataEvent = new EventEmitter<RefreshDataConfig>();
	constructor(
		public data: ServiceData,
		private prj: ProjectService,
		public backface: BackFaceService,
		private tabs: TabsService,
		private eles: ElementsService,
		public current: CurrentService,
		private eleview: EleViewBackFaceService,
		private snackBar: MatSnackBar,
		private curr: CurrentService
	) {}
	ngOnDestroy(): void {
		this.subscribe.forEach(v => v.unsubscribe());
	}
	initByCondition(element: Element, title: string, condition: string) {
		this.backface.eleName = element.Name;
		// å¦ææ²¡ææ¡ä»¶ï¼åç´æ¥åå§å
		if (!title && !condition) {
			this.init(element, this.prj.apiURL(element.Name));
		} else {
			this.backface
				.buildRecordViewURL({
					Title: title,
					Condition: condition
				})
				.subscribe(str => {
					this.init(element, str);
				});
		}
	}
	init(element: Element, url: string) {
		this.element = element;
		this.backface.eleName = element.Name;
		this.backface.url = url;
		this.subscribe.push(
			this.curr.change$.subscribe(() => {
				// tslint:disable-next-line: deprecation
				forkJoin(
					this.backface.fetParamCache(),
					this.eleview.fetchElementAllCategories(element.Name),
					this.backface.fetchElementViewList(),
					this.backface.fetchAllColumns()
				).subscribe(
					([param, categories, columnsList, allColumns]) => {
						if (param.Processes) {
							// æ³¨åç¸å³çelement,å¿é¡»æ¯ç¬¬ä¸æ¶é´æ³¨åï¼åé¢ä¼å¼ç¨å°
							param.Processes.forEach(v => {
								this.eles.addElement({ ...v.Element, NotMenu: true });
							});
							this.data.rowProcesses = this.withDefaultIconProcess(
								param.Processes.filter(one => one.BindRecord)
							);
							this.data.toolbarProcesses = this.withDefaultIconProcess(
								param.Processes.filter(one => !one.BindRecord)
							);
						} else {
							this.data.rowProcesses = [];
							this.data.toolbarProcesses = [];
						}
						this.data.uniqueFields = param.UniqueField;
						if (param.ConditionalTemplates) {
							this.data.conditionalTemplates = param.ConditionalTemplates.map(v =>
								ConditionalTemplateRunner.fromInterface(v)
							);
						}

						this.data.categories = categories;
						this.data.viewList = columnsList;
						this.data.selectedView = defaultColumnsItem;
						this.data.allColumns = allColumns;
						this.data.allColumnNames = allColumns.map(v => v.Name);
						this.data.allColumnsWithLetter = map2WithLetter(this.data.allColumnNames);
						this.paramsChange.next();
						this.refreshData().subscribe();
					},
					(err: HttpErrorResponse) => {
						console.log(err);
						if (err.error.Err.Message) {
							this.snackBar.open(err.error.Err.Message, 'ç¡®å®', { horizontalPosition: 'right' });
						}
					}
				);
			})
		);
	}
	withDefaultIconProcess(process: IRecordViewProcess[]) {
		return process.map(pro => {
			const rev = pro;
			if (!pro.Icon) {
				const ele = this.eles.get(pro.ElementName);
				if (ele.Bill) {
					switch (pro.Element.BillOperate) {
						case BillOperate.Add:
							rev.Icon = 'add';
							break;
						case BillOperate.Edit:
							rev.Icon = 'outlined:create';
							break;
						case BillOperate.Browse:
							rev.Icon = 'outlined:visibility';
							break;
						case BillOperate.Delete:
							rev.Icon = 'outlined:delete';
							rev.Color = 'warn';
							break;
					}
				} else {
					rev.Icon = '';
				}
			}
			return rev;
		});
	}
	refreshRowCount() {
		this.data.fetchParam.View = this.data.selectedView;
		this.data.fetchParam.Labels = this.data.selectedLabels;
		this.data.fetchParam.SelKeys = this.data.tableRowSelection.selected;
		this.data.refreshRowCountProgress = true;
		if (this.data.conditionalTemplates) {
			this.data.fetchParam.ConditionalTemplate = this.data.conditionalTemplates
				.filter(v => v.enable)
				.map(v => v.Data);
		}
		return this.backface.fetchRowCount(this.data.fetchParam).pipe(
			map(v => {
				this.data.rowCount = v.RowCount;
				this.data.refreshRowCountProgress = false;
				return true;
			})
		);
	}
	// seek æææ¯ä¸æ¯æ²¡æå¨è¿æ¡ä»¶ï¼ä»ä»ç¿»é¡µ
	refreshData(config?: RefreshDataConfig) {
		if (config && config.keepDivide) {
			this.data.prevFetchDivide = this.data.fetchParam.Divide;
			this.data.prevFetchRowNum = this.data.fetchParam.DivideRowNum;
		} else {
			this.data.prevFetchDivide = undefined;
			this.data.prevFetchRowNum = undefined;
			this.data.fetchParam.Divide = undefined;
			this.data.fetchParam.DivideRowNum = undefined;
			this.data.upDivide = undefined;
			this.data.upRowNum = undefined;
		}

		this.data.fetchParam.View = this.data.selectedView;
		this.data.fetchParam.Labels = this.data.selectedLabels;
		this.data.fetchParam.SelKeys = this.data.tableRowSelection.selected;
		this.data.refreshDataProgress = true;
		if (this.data.conditionalTemplates) {
			this.data.fetchParam.ConditionalTemplate = this.data.conditionalTemplates
				.filter(v => v.enable)
				.map(v => v.Data);
		}
		return this.backface.fetchData(this.data.fetchParam).pipe(
			map(v => {
				if (v.Error) {
					this.snackBar.open(v.Error, 'ç¡®å®', { duration: 5000 });
					this.data.refreshDataProgress = false;
					return { ok: false, error: v.Error };
				}
				// console.log('=======:', v.FData);
				this.data.tableData = v.FData;
				this.data.timeConsuming = v.TimeConsuming;
				this.data.nextPageDisable =
					(v.FData.RowCount === 0 && v.FData.Rows.length === 0) || v.FData.RowCount > 0;
				this.data.prevPageDisable =
					(v.FData.RowCount === 0 && v.FData.Rows.length === 0) || v.FData.Rows[0].RowNum === 1;
				this.registerURLS();
				if (v.FData.RowCount >= 0) {
					this.data.rowCount = v.FData.RowCount;
				} else {
					if (!config || !config.keepRowCount) {
						this.data.rowCount = -1; // æ¾è¿éå¯ä»¥é²æ­¢çé¢æ å¿è¦å·æ°
					}
				}

				// å¦æåç«¯è¿åtitleï¼åè¯´ææ¯éè¦å¨ææ¹åtitleå¼
				if (v.FData.Title) {
					this.tabs.active.titleObservable.next(v.FData.Title);
				}
				this.refreshDataEvent.emit(config);
				this.data.refreshDataProgress = false;

				return { ok: true };
			})
		);
	}
	// æ³¨åç¸å³çurlçç­¾å
	registerURLS() {
		Object.keys(this.data.tableData.Processes).forEach(v => {
			this.eles.setURLSign(this.data.tableData.Processes[v].URL, this.data.tableData.Processes[v].Sign);
		});
		this.data.tableData.Rows.forEach(row => {
			Object.keys(row.Processes).forEach(v => {
				this.eles.setURLSign(row.Processes[v].URL, row.Processes[v].Sign);
			});
		});
	}
	// è·åæå®ååè®¸ä½¿ç¨çè¿ç®ç¬¦
	private getOperates(col: string) {
		if (!col) {
			return [];
		}
		const colType = DataType[this.data.tableData.Columns.find(c => c.Name === col).Type];
		return [
			{
				Name: '',
				Label: '(æ )'
			} as Operate,
			...Operates.filter(v => v.AllowTypes.includes(colType))
		];
	}
	onColumnChange(colName: string) {
		this.data.Operates = this.getOperates(colName);
		// å¦æä¹åçè¿ç®ç¬¦å·²ç»ä¸å¨åè¡¨ä¸­ï¼åé»è®¤ä¸º æ 
		if (this.data.fetchParam.Opt && !this.data.Operates.find(v => v.Name === this.data.fetchParam.Opt)) {
			this.data.fetchParam.Opt = null;
		}
	}
}
